import React, { useState } from "react"
import {
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Row,
  Col,
  message,
} from "antd"
import NetworkManager from "src/services/PackageNetwork"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectCountry from "src/components/Dropdown/SelectCountry"
import { SectionCard, SectionTitle } from "./styled"
import SelectLocalRoaming from "src/components/Dropdown/SelectLocalRoaming"
import SelectSimType from "src/components/Dropdown/SelectSimType"

const { Option } = Select

const ModalEditContract = ({
  open,
  onCancel,
  record,
  onSuccess,
  onlyView = false,
}) => {
  const [form] = Form.useForm()
  const [countryId, setCountryId] = useState(null)
  const [loading, setLoading] = useState(false)
  // console.log(record, "record")

  const initialValues = {
    ...record,
    supplier: record?.supplier?.name,
    carrier: record?.network?.name,
  }
  console.log(record, "rec")

  const handleFinish = async values => {
    setLoading(true)
    try {
      const payload = {
        ...values,
        then_stop: "",
        daily_total: "",
        date: "",
        // status: "0",
      }
      const response = await NetworkManager.packageUpdate(record.ID, payload)
      message.success("Cập nhật gói cước thành công!")
      onCancel()
      onSuccess?.()
    } catch (error) {
      const errors = error?.response?.data?.errors
      if (errors?.package_code) {
        form.setFields([
          {
            name: "package_code",
            errors: ["Mã gói cước đã tồn tại!"],
          },
        ])
      }

      if (errors?.provider_code) {
        form.setFields([
          {
            name: "provider_code",
            errors: ["Mã gói cước(nhà cung cấp)đã tồn tại!"],
          },
        ])
      } else {
        console.error("Lỗi cập nhật gói cước:", error)
        message.error("Cập nhật gói cước thất bại!")
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      open={open}
      title="Chỉnh sửa gói cước"
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      onOk={form.submit}
      okText="Lưu"
      cancelText="Hủy"
      width={800}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleFinish}
        initialValues={initialValues}
      >
        {/* Thông tin gói cước */}
        <SectionCard>
          <SectionTitle>Thông tin chung</SectionTitle>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Tên gói cước"
                rules={[
                  { required: true, message: "Vui lòng nhập tên gói cước" },
                ]}
              >
                <Input
                  disabled
                  placeholder="Thông tin duy nhất, không thể thay đổi"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="service_type"
                label="Local/Roaming"
                rules={[
                  { required: true, message: "Vui lòng chọn Local/Roaming" },
                ]}
              >
                <SelectLocalRoaming />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="sim_type"
                label="Loại hình SIM"
                rules={[
                  { required: true, message: "Vui lòng chọn loại hình SIM" },
                ]}
              >
                <SelectSimType />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="supplier_id"
                label="Nhà cung cấp"
                rules={[
                  { required: true, message: "Vui lòng chọn nhà cung cấp" },
                ]}
              >
                <SelectProvider />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="country_id"
                label="Quốc gia"
                rules={[{ required: true, message: "Vui lòng chọn quốc gia" }]}
              >
                <SelectCountry
                  disabled={onlyView}
                  onChange={value => {
                    setCountryId(value)
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="network_carrier_id"
                label="Nhà mạng"
                rules={[{ required: true, message: "Vui lòng chọn nhà mạng" }]}
              >
                <SelectCarrier disabled={onlyView} countryId={countryId} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="package_code"
                label="Mã gói cước"
                rules={[
                  { required: true, message: "Vui lòng nhập mã gói cước" },
                  { min: 3, message: "Mã gói cước phải có ít nhất 3 ký tự" },
                ]}
              >
                <Input placeholder="Nhập mã gói cước" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="provider_code"
                label="Mã gói cước(nhà cung cấp)"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập mã gói cước(nhà cung cấp)",
                  },
                  {
                    min: 3,
                    message:
                      "Mã gói cước(nhà cung cấp) phải có ít nhất 3 ký tự",
                  },
                ]}
              >
                <Input placeholder="Nhập mã gói cước(nhà cung cấp)" />
              </Form.Item>
            </Col>
          </Row>
        </SectionCard>

        {/* Cấu hình kỹ thuật */}
        <SectionCard>
          <SectionTitle>Thông tin gói cước</SectionTitle>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="data_quantity"
                label="Dung lượng Data (GB)"
                rules={[
                  { required: true, message: "Vui lòng nhập dung lượng data" },
                ]}
              >
                <InputNumber
                  min={0}
                  placeholder="Nhập số GB"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="package_type"
                label="Mô tả "
                // rules={[{ required: true, message: "Vui lòng nhập mô tả" }]}
              >
                <InputNumber
                  min={0}
                  placeholder="Nhập mô tả"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="price"
                label="Giá (VND)"
                rules={[
                  { required: true, message: "Vui lòng nhập giá gói cước" },
                ]}
              >
                <InputNumber
                  min={0}
                  placeholder="Nhập giá gói cước"
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={value => value.replace(/\₫|\s|,/g, "")}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </SectionCard>
      </Form>
    </Modal>
  )
}

export default ModalEditContract
